/*
 * ---------------------------------------------------------------------------------
 * Copyright:
 *      NewtonGreen Technologies Pty. Ltd.
 *      Level 4, 175 Scott St.
 *      Newcastle, NSW, 2300
 *      Australia
 * 
 *      E-mail: support@newtongreen.com
 *      Tel: (02) 4925 5288
 *      Fax: (02) 4925 3068
 * 
 *      All Rights Reserved.
 * ---------------------------------------------------------------------------------
 */

/*
 * --------------------------------------------------------------------------------
 * This file contains the context for the currently loaded country.
 * --------------------------------------------------------------------------------
 */

/*
 * ---------------------------------------------------------------------------------
 * Imports - External
 * ---------------------------------------------------------------------------------
 */

/*
 * Used to create a context.
 */
import * as React from 'react';

/*
 * ---------------------------------------------------------------------------------
 * Imports - Internal
 * ---------------------------------------------------------------------------------
 */


/*
 * ---------------------------------------------------------------------------------
 * Interfaces
 * ---------------------------------------------------------------------------------
 */
export enum ConsentDialogState {
    None = 0,
    Start = 1,
    Notify = 2,
    Restart = 3,
    Refuse = 4
}

interface IConsentDialogContext {
    dialogState: ConsentDialogState;
    setDialogState: (dialogState: ConsentDialogState) => void;
    patientStudyNumber: string | null;
    setPatientStudyNumber: (patientStudyNumber: string | null) => void;
    institutionCode: string | null | undefined;
}




/*
 * ---------------------------------------------------------------------------------
 * Constants
 * ---------------------------------------------------------------------------------
 */



const ConsentDialogContext = React.createContext<IConsentDialogContext>({
    dialogState: ConsentDialogState.None,
    setDialogState: () => undefined,
    patientStudyNumber: null,
    setPatientStudyNumber: () => undefined,
    institutionCode: null
});

/*
 * ---------------------------------------------------------------------------------
 * Default Export
 * ---------------------------------------------------------------------------------
 */

export default ConsentDialogContext;